import Cookies from 'js-cookie';
import store from '../store';
const TokenKey = 'loginToken';

export function getToken() {
  const token = Cookies.get(TokenKey);
  if (token) {
    return token;
  }
  return '';
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function havePerms(wantPerms) {
  const userPerms = store.state.user.userAuths;
  if (!userPerms) {
    return false;
  }
  for (let i = 0; i < wantPerms.length; i++) {
    if (userPerms.indexOf(wantPerms[i]) == -1) {
      return false;
    }
  }
  return true;
}
// 满足一个即返回true
export function haveRoutePerms(wantPerms) {
  const userPerms = store.state.user.userAuths;
  if (!userPerms) {
    return false;
  }
  for (let i = 0; i < wantPerms.length; i++) {
    if (userPerms.indexOf(wantPerms[i]) > -1) {
      return true;
    }
  }
  return false;
}
export function havePerm(wantPerm) {
  const userPerms = store.state.user.userAuths;
  if (!userPerms) {
    return false;
  }
  if (userPerms.indexOf(wantPerm) == -1) {
    return false;
  }
  return true;
}

export function permDirective(el, binding) {
  const wantPerms = binding && binding.value && binding.value.split(',');
  if (wantPerms && !havePerms(wantPerms)) {
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js